import {
  type WhiteboardSessionData,
  type RawContentAPI,
  type WhiteboardQueryParams,
  type OnboardingStartHandler,
  type RawFrameToken,
  type ContainerHandler,
  type RawTokenHandler,
  UserTypes,
} from '@canvas/frame-api-types';
import { unlockAllPaywallsResponseMock } from '@canvas/paywall-test-utils';
import { noop, noopAsync } from '@canvas/utils';

export class NoopContentAPI implements RawContentAPI {
  public sessionData: WhiteboardSessionData = {
    accountId: 'noop-account-id',
    tenantId: 'noop-tenant-id',
    publicLinkUserType: UserTypes.CONFLUENCE_USER,
  };

  public goToContainer = noop;
  public goToHome = noop;
  public goToContent = async (_id: string, _query?: WhiteboardQueryParams) => {};
  public onRouteChange = (_handler: (route: string) => void) => {};

  public onContainerChange = noop;
  public onContentLoadSucceeded = noop;
  public onContentLoadFailed = noop;
  public onContentLoadAborted = noop;

  public isFeatureActive = () => true;
  public registerStartOnboardingCallback: (cb: OnboardingStartHandler) => void = noop;
  public onOnboardingChange = noop;
  public onOnboardingEnd = noop;

  public updateCollaborators = noop;
  public updateMainActions = noop;
  public updateMoreActions = noop;
  public updateBoardStatus = noop;

  public refreshToken = noopAsync;
  public preloadToken = noopAsync;
  public preloadContent = noopAsync;

  public onTokenInit = async (_handler: RawTokenHandler) => {};
  public onTokenChange = (_handler: RawTokenHandler) => {};
  public onContainerInit = (_handler: ContainerHandler) => {};

  public getToken = async (): Promise<RawFrameToken> => ({
    container: '',
    board: '',
    accessToken: '',
    mediaToken: '',
    mediaBaseUrl: '',
    mediaCollectionId: '',
    features: unlockAllPaywallsResponseMock,
  });

  public showEditionUpgradeCTA = noopAsync;

  public closeEditionUpgradeCTA = noop;

  public onThemeChange = noop;

  public onOnboardingReady = noop;

  public registerOnReopenResolvedComment = noop;
  public registerEventHandler = noop;
  public unregisterEventHandler = noop;
  public triggerIntegration = noopAsync;
  public checkIntegration = () => false;

  public isExternalShareRequest = false;
  public getPublicLink = () => ({
    isEnabled: false,
    isEditEnabled: false,
    refetch: noop,
  });
  public refetchPublicLink = noop;
}
